export default {
  token: state => state.app.token,
  isLogin: state => !!state.app.token,
  breadListState: state => JSON.parse(sessionStorage.getItem('breadListStorage')) || []
};
